const staticPixels = "\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-VRT25XEC7T&l=dataLayer\"></script>";
const pixelsCategories = ["STRICTLY_NECESSARY","TARGETING"];

export { staticPixels };
export { pixelsCategories };